import httpClient, { financeHttpClient } from '../../api/httpClient'
import { caseOf, filter, HTTP, map } from '../../lib'

import { Paginate } from '../../lib/types/Paginate'

export default {
  namespaced: true,

  state: {
    payments: HTTP.Request.Inactive(),
    paymentDates: HTTP.Request.Inactive(),
    selectedPaymentDate: null,
    paymentDateRaw: null,
    userPaymentParts: {},
    selectedPaymentErrorType: 0,
    selectedMarket: 'ALL',
    pagination: { ...Paginate.defaultState },
    currentPaymentId: null,
    paymentsList: {},
  },

  mutations: {
    update: (state, { path, value }) => {
      state[path] = value
    },

    setPayments: (state, payments) => {
      state.payments = payments
    },
    setPaymentDates: (state, paymentDates) => {
      state.paymentDates = paymentDates
    },
    setPaymentsToInvoice: (state, { paymentInvoiceId, newPayments }) => {
      caseOf(state.payments, {
        Done: (payments) => {
          state.payments = HTTP.Request.Done(
            map(payments, (paymentsInvoice) => {
              if (paymentInvoiceId == paymentsInvoice.id) {
                paymentsInvoice.payments = newPayments
              }
              return paymentsInvoice
            }),
          )
        },
        _: () => null,
      })
    },
    setPaymentInvoiceToApproved: (state, { paymentInvoiceId }) => {
      caseOf(state.payments, {
        Done: (payments) => {
          state.payments = HTTP.Request.Done(
            map(payments, (paymentsInvoice) => {
              if (paymentInvoiceId == paymentsInvoice.id) {
                paymentsInvoice.total_payment.is_approved = 1
              }
              return paymentsInvoice
            }),
          )
        },
        _: () => null,
      })
    },

    setPaymentAcceptedAt: (state, newPayment) => {
      Object.keys(state.paymentsList).forEach(function (paymentPageKey) {
        const foundPayment = state.paymentsList[paymentPageKey].find((o) => o.id === newPayment.id)
        foundPayment.accepted_at = newPayment.accepted_at
        foundPayment.accepted_by = newPayment.accepted_by
      })
    },

    setRecalculate: (state) => {
      caseOf(state.payments, {
        Done: () => {
          // state.payments = HTTP.Request.Done(
          //   map(payments, paymentsInvoice => {
          //       console.log(paymentsInvoice.payments.data)
          //       paymentsInvoice.payments.data = map(paymentsInvoice.payments.data, payment  => {
          //         if (payment.id === payment_id){
          //           payment.recalculate = true;
          //         }
          //         return payment;
          //       });
          //     return paymentsInvoice;
          //   })
          // )
        },
        _: () => [],
      })
    },

    setUserPaymentParts: (state, { id, data }) => {
      state.userPaymentParts[id] = data
    },
  },
  getters: {
    payments: ({ payments }) => payments,
    paymentsForTD: ({ payments }) => {
      return caseOf(payments, {
        Done: (payments) => {
          return filter(payments, function (payment) {
            return payment.send_to_TD
          })
        },
        _: () => null,
      })
    },
    paymentDates: ({ paymentDates }) => paymentDates,
    selectedPaymentDate: ({ selectedPaymentDate }) => selectedPaymentDate,
    selectedMarket: ({ selectedMarket }) => selectedMarket,
    paymentDateRaw: ({ paymentDateRaw }) => paymentDateRaw,
    paymentsListPerPage: ({ paymentsList, pagination: { current } }) => paymentsList[current] || [],
  },

  actions: {
    init({ commit, dispatch }) {
      commit('setPaymentDates', HTTP.Request.Pending())

      return httpClient
        .get(`/paymentsInvoice/dates`)
        .then((response) => {
          commit('setPaymentDates', HTTP.Request.Done(response.data))
          response.data.forEach((PaymentDates) => {
            if (PaymentDates.selected) {
              dispatch('selectPaymentDate', { value: PaymentDates.payment_date })
            }
          })
        })
        .catch((err) => commit('setPaymentDates', err))
    },

    /**
     * Get all payment dates
     * @param {*} a date on format 2019-10-01
     */
    selectPaymentDate({ commit, state, dispatch }, { value }) {
      const selectedDate = value
      commit('update', { path: 'selectedPaymentDate', value: selectedDate })
      dispatch('getPaymentDate', { date: selectedDate })
      return httpClient
        .get(`/paymentsInvoice`, {
          params: {
            paymentDate: selectedDate,
            paymentErrorType: state.selectedPaymentErrorType,
            market: state.selectedMarket,
          },
        })
        .then((response) => {
          commit('setPayments', HTTP.Request.Done(response.data))
        })
        .catch((err) => commit('setPaymentDates', err))
    },
    selectPaymentTypes({ commit, state }, { value }) {
      commit('update', { path: 'selectedPaymentErrorType', value: value })
      return httpClient
        .get(`/paymentsInvoice`, {
          params: {
            paymentDate: state.selectedPaymentDate,
            paymentErrorType: value,
            market: state.selectedMarket,
          },
        })
        .then((response) => {
          commit('setPayments', HTTP.Request.Done(response.data))
        })
        .catch((err) => commit('setPaymentDates', err))
    },

    selectMarket({ commit, state }, { value }) {
      commit('update', { path: 'selectedMarket', value: value })
      return httpClient
        .get(`/paymentsInvoice`, {
          params: {
            paymentDate: state.selectedPaymentDate,
            paymentErrorType: state.selectedPaymentErrorType,
            market: value,
          },
        })
        .then((response) => {
          commit('setPayments', HTTP.Request.Done(response.data))
        })
        .catch((err) => commit('setPaymentDates', err))
    },

    /**
     * Get all payments for a paymentInvoice
     * @param paymentInvoiceId
     */
    loadPayments({ commit, state }, page = 1) {
      const { selectedPaymentErrorType, currentPaymentId, pagination } = state
      const params = {
        payment_error_type: selectedPaymentErrorType,
        payments_invoice_id: currentPaymentId,
        sort_by: 'creator_cost',
        page,
      }

      Paginate.setCurrentPage({ pagination, page, commit, url: '/payments', params, client: financeHttpClient })
        .then((response) => {
          if (response) {
            const { current_page, items } = response.data
            let value = { [current_page]: items }
            if (current_page !== 1) {
              value = { ...state.paymentsList, ...value }
            }
            commit('update', { path: 'paymentsList', value })
          }
        })
        .catch((err) => {
          console.error("Couldn't load payments, ", err)
        })
    },

    loadUserPaymentParts({ commit }, id) {
      return httpClient
        .get(`/payments/${id}/user-parts`)
        .then((response) => {
          if (response && response.data) {
            commit('setUserPaymentParts', { id, data: response.data })
          }
          return response
        })
        .catch(() => {
          commit('setUserPaymentParts', { id, data: [] })
        })
    },

    /**
     * Approve a payment
     * @param payment_id
     */
    approvePayment({ commit }, { value }) {
      return httpClient.get(`/payments/` + value + '/approve').then((response) => {
        commit('setPaymentAcceptedAt', response.data)
      })
    },
    unapprovePayment({ commit }, { value }) {
      return httpClient.get(`/payments/` + value + '/unapprove').then((response) => {
        commit('setPaymentAcceptedAt', response.data)
      })
    },

    recalculatePayment({ commit }, { value }) {
      commit('setRecalculate', { payment_id: value })
      return httpClient.get(`/payments/` + value + '/recalculate').then(() => {
        alert('Recalculating refresh after 1 min.')
      })
    },

    /**
     * Approve a paymentInvoice
     * @param payment_invocie_id
     */
    approvePaymentInvoice({ commit, dispatch }, { value }) {
      return httpClient.get(`/paymentsInvoice/` + value + '/approve').then(() => {
        dispatch('loadPayments', 1)
        commit('setPaymentInvoiceToApproved', { paymentInvoiceId: value })
      })
    },

    lockPaymentDate({ commit }, { date }) {
      return httpClient
        .post(`/payments/lock-payment-date`, {
          date: date,
        })
        .then((response) => {
          commit('update', { path: 'paymentDateRaw', value: response.data })
        })
        .catch((err) => console.log(err))
    },

    getPaymentDate({ commit }, { date }) {
      return httpClient
        .get(`/payments/get-payment-date`, {
          params: {
            date: date,
          },
        })
        .then((response) => {
          commit('update', { path: 'paymentDateRaw', value: response.data })
        })
    },
    async downloadDoubtfulDebtReport() {
      try {
        const response = await financeHttpClient.get('/reports/doubtful-debt', {
          responseType: 'blob',
        })
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        const today = new Date().toISOString().split('T')[0]
        link.setAttribute('download', `doubtful-debt-report-${today}.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(downloadUrl)
      } catch (err) {
        console.error('Error downloading doubtful debt report:', err)
        throw err
      }
    },
  },
}
